export const constants = {
    access_token : '',
    MRS: {
        'SMARTNAME': 'SMT',
        'DOMAINNAME': 'DFS'
    },
    PASE_URLS: {
        'DEV': 'http://dev.siext.amadeus.net:25001/{SAPID}/v1/atrapi/',
        'USR': 'http://blrrndobedev243.rnd.amadeus.net:25509/1ASIUFDB/v1/atrapi/',
        'PDT': 'https://test-airlineretailing.amadeus.com:51420/{SAPID}/v1/atrapi/',
        'UAT': 'https://test-airlineretailing.amadeus.com:51420/{SAPID}/v1/atrapi/',
        'MIG': 'https://test-airlineretailing.amadeus.com:51420/{SAPID}/v1/atrapi/',
        'SKL': 'https://test-airlineretailing.amadeus.com:51420/{SAPID}/v1/atrapi/',
        'BTPRD': 'https://test-airlineretailing.amadeus.com:51420/{SAPID}/v1/atrapi/',
        'PRD': 'https://airlineretailing.amadeus.com:51420/{SAPID}/v1/atrapi/'
    },
    CLP_URL : {
        'url': "https://{ENV}.accounts.amadeus.com/LoginService/authorizeAngular?service=atrapp&client_id={SAPID}&redirect_uri="
    },
    SAP_ID : {
        'PDT' : "1ASIUMRS",
        'PRD' : "1ASIUMRS",
        'PPT' : "1ASIUMRS",
        'UAT' : "1ASIUMRSU",
        'MIG' : "1ASIUMRSM",
        'BTPRD' : "1ASIUARP1AR",
        'SKL' : "1ASIUMRSK",
        'DEV' : "1ASIUMRSD"
    },
    APP_CONFIG : {
        'www.audits.amadeus.com': 'prd',
        'dev.audits.amadeus.com': 'dev',
        'pdt.audits.amadeus.com': 'pdt',
        'uat.audits.amadeus.com': 'uat',
        'mig.audits.amadeus.com': 'mig',
        'skl.audits.amadeus.com': 'skl',
        'ppt.audits.amadeus.com': 'ppt',
        'localhost:4200': 'dev'
    }
 };